/**
 * Quotation Service API
 * This is the quotation-service API generated by springdocs - a library for OpenAPI 3 with spring boot.
 *
 * The version of the OpenAPI document: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RfqPropertyDto } from './rfqPropertyDto';
import { QuotationDto } from './quotationDto';


export interface RfqDto { 
    id?: number;
    uid?: string;
    profile?: string;
    type?: string;
    number?: string;
    status?: string;
    dueDate?: Date;
    fullName?: string;
    phone?: string;
    email?: string;
    contact?: string;
    information?: string;
    importance?: string;
    coverage?: number;
    dailyKwUsage?: number;
    day?: number;
    night?: number;
    dayUsage?: number;
    nightUsage?: number;
    createdByDate?: Date;
    property?: RfqPropertyDto;
    quotations?: Array<QuotationDto>;
}

